<template>
	<div class="panel_sale">
		<div class="list" v-if="type==='list'">
			<giftCardList></giftCardList>
		</div>
	</div>
</template>
<script>
	import giftCardList from "./comp/giftCard_list.vue"
	export default {
		components:{giftCardList},
		data(){
			return{
				
			}
		},
		computed:{
			type(){
				return this.$store.state.giftCard.type;
			}
		},
		mounted(){
			
		},
		methods: {
			
		},
	}
</script>
<style scoped lang="scss">
.panel_sale{
	position: relative;
	width:100%;
	height: 100%;
	background-color: #fff;
	.settlementBox{
		position: absolute;
		bottom:0;
		width:100%;
	}
	.list{
		height: 100%;
	}
	.add{
		height: 100%;
	}
}
</style>
